import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom';
import { createRoot } from 'react-dom/client';

const dateNow = new Date();
const root = createRoot(document.getElementById('root'));
const baseName = document.querySelector('base')?.getAttribute('href') ?? '/';

root.render(
    <React.StrictMode>
        <BrowserRouter basename={baseName}>
            <App/>
        </BrowserRouter>
        <footer className="App-footer container">
            <p>© {dateNow.getFullYear()} NutriCherry / TheCodersCorner.com. Application version {process.env.REACT_APP_NAME} {process.env.REACT_APP_VERSION} </p>
            <p><a href="/legal/privacy">Privacy policy and terms of use</a></p>
        </footer>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
